<template>
    <div class="relative w-screen h-screen">
        <div class="fixed w-full z-[9999] bg-white top-0 md:top-auto md:bottom-0">
            <OverlayBar />
        </div>
        <CoohomeIframe></CoohomeIframe>
    </div>
</template>
<script>
import OverlayBar from "@/components/OverlayBar.vue";
import CoohomeIframe from '@/components/CoohomeIframe.vue';
export default {
    components: { 
        OverlayBar,
        CoohomeIframe }
}
</script>